import { roles } from "shared/constants/Constants.js";

const rolesPermissionsRoutes = {
  dashboard: [],
  standalone: [
    {
      path: "/roles-permissions",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "roles-permissions" */
          "./pages/RolesPermissions.js"
        ),
      protected: false,
      authorized: [
        roles.ADMIN,
        roles.HUB_MANAGER,
        roles.SENIOR_DRIVER_MANAGER,
        roles.DRIVER_MANAGER,
        roles.FINANCE,
        roles.COMMERCIAL,
      ],
    },
  ],
};

export default rolesPermissionsRoutes;
